import { useQuery } from '@apollo/client';
import { GET_CATEGORIES } from '../../../../../../api/query';

const useGetAllCategories = () => {
  const { data } = useQuery(GET_CATEGORIES);
  return { categories: data?.adminCategories };
};
export default useGetAllCategories;
